import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';
import MfaVerify from '../auth/MfaVerify';

const ProtectedRoute = ({ children, allowedRoles, platformAdmin = false }) => {
  const { user, isAuthenticated, loading, userRole, mfaStatus } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 'verify' means this token hasn't passed MFA yet on an already-enrolled account — a real gate, since
  // the server rejects every other request until it's done. 'setup' (privileged but never enrolled) is
  // only a nudge shown once right after login/register (see LoginForm) — it does not block every page.
  if (mfaStatus === 'verify') {
    return <MfaVerify />;
  }

  // Pages only for platform administrators (the server enforces this too).
  if (platformAdmin && !user?.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  platformAdmin: PropTypes.bool
};

export default ProtectedRoute;
